// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1-E-v","checkboxCol":"Table_checkboxCol__1AIw0","emailCol":"Table_emailCol__2tNI3","actionCol":"Table_actionCol__nKZ2t"};